/**
 * Narrows the operations buildAttachOperations produced down to the documents
 * a single-card or partial-batch attach actually covers.
 *
 * Every operation carries the index of the result it came from, except the
 * trip-level general-information sections, which carry `resultIndex: null`
 * because they belong to no single document -- they are merged across every
 * itinerary document uploaded (documentImportMergeTripInfo) and cannot be
 * cleanly split per card. Those are never filtered out here: whichever attach
 * call runs first -- one card or a batch of several -- is the one that gets to
 * post them, so they must stay in scope no matter which result indexes were
 * asked for.
 */
function filterAttachOperationsByResult(operations, resultIndexes) {
  const wanted = new Set(resultIndexes || []);
  return (operations || []).filter(
    op => op.resultIndex === null || wanted.has(op.resultIndex),
  );
}

module.exports = { filterAttachOperationsByResult };
